import type { WritableDraft } from 'immer';
import { compact } from 'lodash-es';
import type { Option } from '../OMS/NewOrder/models';

// ID used to store and retrieve DDH order form defaults in app config
export function getDDHDefaultsID(option: WritableDraft<Option>): string {
  const data = option.data;
  return compact([data.exchangeField.value?.value, data.coinField.value?.value]).join('-');
}
